/**
 * Helper to check if production-like mode is enabled
 * When NEXT_PUBLIC_PRODUCTION_MODE=true, the app will look exactly like production
 * (no development colors, no breakpoint indicators, etc.)
 */
export function isProductionModeEnabled(): boolean {
  return process.env.NEXT_PUBLIC_PRODUCTION_MODE === "true";
}


